import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Product } from 'src/services/product';
import { ProductService } from 'src/services/productservice';

@Component({
  selector: 'app-islands-all',
  templateUrl: './islands-all.component.html',
  styleUrls: ['./islands-all.component.scss'],
})
export class IslandsAllComponent implements OnInit {
  public title: string;
  public subtitle: string;
  public inner: string;
  products: Product[];
  responsiveOptionsActivity: any;
  responsiveOptions: any;
  islandsAccom: any;
  islandType: any;
  islandsBannerAndContent: any = { bannerImage: null, bannerTitle: null, content: null };
  IslandsAccom: any;
  bannerImage: any;
  islandsGroup: any;
  islandsGroups: any;
  islandsGroupId: any;
  viewNode: string;
  images: any = [];
  activeIndex: any;
  displayCustom: boolean;

  constructor(private route: ActivatedRoute, private productService: ProductService, private router: Router) {
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 3,
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 2,
      },
      {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.islandType = params['islandType'];
      this.IslandsAccom = params['IslandsAccom'];
      this.islandsGroup = params['islandsGroup'];
      this.islandsGroupId = params['islandsGroupId'];
      this.getDetails();
    });
  }
  getDetails() {
    if (this.islandType == 'innerIslands') {
      this.productService.getinnerIslandsBannerAndContent().then((innerIslands) => {
        if (innerIslands) {
          this.islandsBannerAndContent = innerIslands;
          if (this.islandsBannerAndContent.bannerImage) {
            this.bannerImage = this.islandsBannerAndContent.bannerImage;
          } else {
            this.bannerImage = '../../../assets/images/NoImage.jpg';
          }
        }
      });
      if (this.IslandsAccom == 'islandsWithAccom') {
        this.productService.getInnerIslandsWithAccom().then((innerIslands) => {
          if (innerIslands) {
            this.islandsAccom = innerIslands;
          }
        });
      } else if (this.IslandsAccom == 'islandsWithoutAccom') {
        this.productService.getInnerIslandsWithoutAccom().then((innerIslands) => {
          if (innerIslands) {
            this.islandsAccom = innerIslands;
          }
        });
      }
    } else if (this.islandType == 'outerIslands') {
      this.productService.getouterIslandsBannerAndContent().then((outerIslands) => {
        if (outerIslands) {
          this.islandsBannerAndContent = outerIslands;
          if (this.islandsBannerAndContent) {
            if (this.islandsBannerAndContent.bannerImage) {
              this.bannerImage = this.islandsBannerAndContent.bannerImage;
            } else {
              this.bannerImage = '../../../assets/images/NoImage.jpg';
            }
            this.images.push(this.bannerImage);
          }
        }
      });
      if (this.IslandsAccom == 'islandsWithAccom') {
        this.productService.getOuterIslandsWithAccom().then((outerIslands) => {
          if (outerIslands) {
            this.islandsAccom = outerIslands;
          }
        });
      } else if (this.IslandsAccom == 'islandsWithoutAccom') {
        this.productService.getOuterIslandsWithoutAccom().then((outerIslands) => {
          if (outerIslands) {
            this.islandsAccom = outerIslands;
          }
        });
      } else if (this.islandsGroup == 'outerIslandGroups') {
        this.productService.getIslandGroups().then((outerIslands) => {
          if (outerIslands) {
            this.islandsGroups = outerIslands;
          }
        });
      } else if (this.islandsGroupId) {
        this.productService.getIslandGroupDetails(this.islandsGroupId).then((outerIslands) => {
          if (outerIslands) {
            this.islandsAccom = outerIslands;
          }
        });
      }
    }
  }

  islands(view_node: string) {
    /*let url;
    if (view_node.indexOf('/fr/') > -1) {
      url = view_node.split('/fr/');
      this.viewNode = url[1];
    } else if (view_node.indexOf('/de/') > -1) {
      url = view_node.split('/de/');
      this.viewNode = url[1];
    } else {
      url = view_node.substring(1, view_node.length);
      this.viewNode = url;
    }*/
    this.viewNode = this.productService.getBlogViewNode({ view_node: view_node });
    this.router.navigate(['/island-details'], {
      queryParams: { view_node: this.viewNode },
    });
  }
  islandGroups(item: any) {
    this.router.navigate(['/island-groups'], {
      queryParams: { id: item.tid },
    });
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
